import { render, staticRenderFns } from "./SalesRatio.vue?vue&type=template&id=34eb98e5"
import script from "./SalesRatio.vue?vue&type=script&lang=js"
export * from "./SalesRatio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports